// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { CustomGetQuoteApiParameter, getCartId } from "@ces/App/Services/QuoteService";
import {
    ApiHandlerDiscreteParameter,
    HasOnError,
    HasOnSuccess,
    createHandlerChainRunner,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";

type HandlerType = ApiHandlerDiscreteParameter<
    CustomGetQuoteApiParameter & HasOnSuccess<QuoteGetCartIdResult> & HasOnError<string>,
    CustomGetQuoteApiParameter,
    QuoteGetCartIdResult
>;

export interface QuoteGetCartIdResult {
    result: string;
    successful?: boolean;
    errorMessage?: string;
}

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        quoteNumber: props.parameter.quoteNumber,
    };
};

export const SendDataToApi: HandlerType = async props => {
    props.apiResult = (await getCartId(props.apiParameter)) as any;
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult?.successful) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.apiResult.errorMessage as any);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult?.successful) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.(props.apiResult);
    }
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnErrorCallback, ExecuteOnSuccessCallback];

const quoteGetCartId = createHandlerChainRunner(chain, "quoteGetCartId");
export default quoteGetCartId;
